/* unplugin-vue-components disabled */import { render } from "./PoolTransferOwnershipPage.vue?vue&type=template&id=3f03ac26"
import script from "./PoolTransferOwnershipPage.vue?vue&type=script&lang=js"
export * from "./PoolTransferOwnershipPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__